import { ClientSettingTypeEnum, ContextSettings } from '@/dto';
import {
    ISettingsChangeServiceData,
} from '../settingsChangeServiceContract';
import { ChangedSetting, OffsetsBlockSettingsChangeServiceData, ClientSettingsChangeServiceData } from './';

export class SettingsChangeServiceData implements ISettingsChangeServiceData {
    public changes: ChangedSetting[];
    public forDeleteGlobals: string[];
    public forDeleteTableLayouts: string[];
    public settingsTypes: { [key: string]: ClientSettingTypeEnum };
    public indicators: string[];
    public offsetBlockSettings: OffsetsBlockSettingsChangeServiceData;
    public clientSettings: ClientSettingsChangeServiceData;

    constructor(data: ContextSettings) {
        this.changes = [];
        this.forDeleteGlobals = [];
        this.forDeleteTableLayouts = [];
        this.settingsTypes = data.settingsTypes || {};
        this.indicators = [];
        this.offsetBlockSettings = new OffsetsBlockSettingsChangeServiceData(data.global);
        this.clientSettings = new ClientSettingsChangeServiceData(data.global);
    }
}
